module.exports = __webpack_public_path__ + "media/images/file-icons/256/007-folder-60a3010d100f9714cb05e3e100b4dde1.png";